import { Size } from '../../typings/common';
import { CreativeImageData } from '../common/typings';

import {
    CreativeImageCropModalState,
    CreativeImageCropSize,
    CreativeImageCropSizeData,
    CreativeImageCropSizesData
} from './typings';

export const selectCreativeImageData = (state: CreativeImageCropModalState): CreativeImageData => {
    const { imageData } = state;

    if (!imageData) {
        throw "Couldn't find imageData!";
    }

    return imageData;
};

export const selectCreativeSizeData = (state: CreativeImageCropModalState): CreativeImageCropSizeData => {
    const { sizeData } = state;

    if (!sizeData) {
        throw "Couldn't find sizeData!";
    }

    return sizeData;
};

export const selectCreativeCropData = (state: CreativeImageCropModalState): CreativeImageCropSizesData => {
    const { cropData } = state;

    if (!cropData) {
        throw "Couldn't find cropData!";
    }

    return cropData;
};

export const selectCreativeCurrentSize = (
    sizeData: CreativeImageCropSizeData,
    selectedSize: number
): CreativeImageCropSize => {
    const { cropSizes } = sizeData;
    const size = cropSizes.find(sizeElem => sizeElem.id === selectedSize);

    if (!size) {
        throw "Couldn't find selected creative size!";
    }

    return size;
};

export const selectCreativeNaturalImageSize = (imageData: CreativeImageData): Size => {
    const { naturalImageSize } = imageData;

    if (!naturalImageSize) {
        throw "Couldn't find naturalImageSize!";
    }

    return naturalImageSize;
};
